import app from '../../../scripts/app';

app.factory('geoSelectorService', [
  '$window',
  '$timeout',
  '$q',
  'config',
  ($window, $timeout, $q, config) => {
    let loadProm;

    function loadScript(path, callback) {
      const el = document.createElement('script');
      el.onload = el.onreadystatechange = () => {
        if (el.readyState && el.readyState !== 'complete' && el.readyState !== 'loaded') {
          return;
        }
        el.onload = el.onreadystatechange = null;
        if (callback) {
          callback();
        }
      };
      el.async = true;
      el.src = path;
      document.getElementsByTagName('body')[0].appendChild(el);
    }

    // eslint-disable-next-line max-len
    // geoType - тип местоположения, который определили по точке, которое ты передаешь в geo.address при публикации (допустимые значения при подаче - house, street, location)
    return {
      ready: callback => {
        if (!loadProm) {
          const deferred = $q.defer();

          loadProm = deferred.promise;

          const apiKey = config.get('b2b.YandexApiKey');

          // eslint-disable-next-line max-len
          loadScript(
            `https://enterprise.api-maps.yandex.ru/2.1/?apikey=${apiKey}&load=package.standard,package.geoObjects&mode=release&lang=ru-RU`,
            () => {
              deferred.resolve($window.ymaps);
            },
          );
        }

        loadProm.then(ymaps => {
          ymaps.ready(() => $timeout(() => callback(ymaps)));
        });
      },
    };
  },
]);
